export default __webpack_public_path__ + "static/media/waiting_for_payment_active.b222ebc2.svg";